<template>
    <bita-modal
        id="product-relation"
        :is-loading="isLoadingModal"
        :modal-lg="true"
        title="محصولات مرتبط"
        @close="reset()"
    >
        <div slot="body">
            <bita-form ref="relationForm">
                <div slot="body">
                    <div class="row">
                        <bita-select-server
                            name="products"
                            ref="products"
                            label="محصول"
                            rules="required"
                            :validation-container-class="colWidth"
                            subtitle="لطفا محصول مورد نظر را جستجو نمایید."
                            input-class="form-control"
                            :data-source="products"
                            data-text-field="name"
                            data-value-field="id"
                            :get-data="getProducts"
                            v-model="formData.related_product_id"
                        />
                        <bita-select
                            label="نوع"
                            name="type"
                            ref="type"
                            :validation-container-class="colWidth"
                            rules="required"
                            input-class="form-control"
                            :data-source="type"
                            data-text-field="name"
                            data-value-field="id"
                            v-model="formData.type"
                        />
                    </div>
                    <bita-bootbutton
                        title="ثبت"
                        type="primary mb-3"
                        icon="fas fa-save"
                        btn-width="150px"
                        @click.native="submit"
                        :disabled="isLoadingModal"
                    />
                </div>
            </bita-form>
        <bita-grid
            v-if="showGrid"
            ref="relationGrid"
            :columns="gridColumns"
            :read-data="readData"
            :page-size="pageSize"
            :has-row-number="true"
        />
        </div>
    </bita-modal>
</template>
<script>
import {
  productApi,
} from "@/api/apiManagement";
export default {
    data() {
        return {
            pageSize: 10,
            colWidth: "col-4",
            isLoadingModal: false,
            showGrid: false,
            type: [
                { id: 1, name: "محصولات مشابه" },
                { id: 2, name: "محصولات مرتبط" }
            ],
            product: {},
            filters: {},
            products: [],
            formData: {},
        }
    },
    computed: {
        gridColumns() {
            return [
                { title: "نام", template: e => ( e.product_id && e.product && e.product.name ? e.product.name : '-') },
                { title: "نوع", template: e => ( e.type && e.type_text ? e.type_text : '-') },
                { title: "عملیات", command: this.gridCommands() }
            ]
        }
    },
    methods: {
        setInitialData(_data) {
            this.showGrid = true;
            this.product = _data;
        },
        readData(e) {
            this.isLoadingModal = true;
            productApi.getProductRelations(this.product.id)
                .then( (res) => {
                    e.success(res.data.entity);
                })
                .catch( () => e.success([]) )
                .finally( () => this.isLoadingModal = false );
        },
        loadData() {
            this.$refs.relationGrid.loadDataSource();
        },
        gridCommands() {
            let commands = [];
            commands.push({
                text: "delete",
                click: this.delete,
                template: this.gridButtons.delete
            });
            return commands;
        },
        delete(e) {
            let relation = this.$refs.relationGrid.getSelectedGridRow(e);
            this.$alert("question", `آیا از حذف ${relation.product.name} اطمینان دارید؟`, "", {
                confirmButtonText: "بله",
            }).then((result) => {
                if (result.value) {
                this.isLoadingModal = true;
                productApi.deleteProductRelation(this.product.id, relation.id)
                    .then((res) => {
                        this.$izitoast("success", "موفق!", res.data.message);
                        this.loadData();
                    })
                    .finally( () => this.isLoadingModal = false );
                }
            });
        },
        getProducts(e) {
            let filter = {
                search: e.filter?.value
            };
            productApi.getProducts(filter)
                .then( (res) => {
                    this.products = _.unionBy(res.data, this.products, "id")
                })
        },
        submit() {
            this.$refs.relationForm.validate()
                .then ( (res) => {
                    if ( res ) {
                        this.isLoadingModal = true;
                        productApi.postProductRelation(this.product.id, this.formData)
                            .then ( (res) => {
                                this.$izitoast("success", "موفق!", res.data.message);
                                this.loadData();
                                this.resetSelect();
                            })
                            .finally( () => this.isLoadingModal = false );
                    }
                })
        },
        resetSelect() {
            this.$refs.products.clear();
            this.$refs.type.emptyKendo();
        },
        reset() {
            this.product = {};
            this.showGrid = false;
        }
    }
}
</script>